import type { AssistedAffiliationRequest } from '../types';

// Datos de ejemplo mientras no existe el endpoint de consulta. Cubre los seis estados a
// propósito y se mantiene ordenado del más reciente al más antiguo, que es el orden que la
// vista debe mostrar.
export const SAMPLE_REQUESTS: AssistedAffiliationRequest[] = [
  {
    id: '000125',
    registryNumber: '000125',
    createdAt: '2025-06-22T10:30:00',
    identification: '101010101',
    commercialName: 'Ferretería XYZ, SRL',
    legalRepresentative: 'Juan Pérez',
    status: 'DRAFT',
    bhdExecutive: 'JPEREZ',
    commercialAssignee: 'María Gómez',
  },
  {
    id: '000124',
    registryNumber: '000124',
    createdAt: '2025-06-21T13:15:00',
    identification: '202020202',
    commercialName: 'Comercial ABC, SRL',
    legalRepresentative: 'Ana López',
    status: 'PENDING_INFORMATION',
    bhdExecutive: 'MLOPEZ',
    commercialAssignee: 'Carlos Ruiz',
  },
  {
    id: '000123',
    registryNumber: '000123',
    createdAt: '2025-06-20T11:05:00',
    identification: '303030303',
    commercialName: 'Súper Tienda 123, SRL',
    legalRepresentative: 'Pedro Martínez',
    status: 'COMMERCE_CREATED',
    bhdExecutive: 'CAROR',
    commercialAssignee: 'María Gómez',
  },
  {
    id: '000122',
    registryNumber: '000122',
    createdAt: '2025-06-19T09:40:00',
    identification: '404040404',
    commercialName: 'Inversiones Palma, SRL',
    legalRepresentative: 'Luis Palma',
    status: 'REQUEST_CANCELLED',
    bhdExecutive: 'JPEREZ',
    commercialAssignee: 'Carlos Ruiz',
  },
  {
    id: '000121',
    registryNumber: '000121',
    createdAt: '2025-06-18T16:55:00',
    identification: '505050505',
    commercialName: 'Distribuidora Global, SRL',
    legalRepresentative: 'Roberto Díaz',
    status: 'DRAFT',
    bhdExecutive: 'MLOPEZ',
    commercialAssignee: 'María Gómez',
  },
  {
    id: '000120',
    registryNumber: '000120',
    createdAt: '2025-06-17T15:20:00',
    identification: '606060606',
    commercialName: 'Colmado La Esquina, SRL',
    legalRepresentative: 'Carmen Reyes',
    status: 'IN_PROGRESS',
    bhdExecutive: 'CAROR',
    commercialAssignee: 'Carlos Ruiz',
  },
  {
    id: '000119',
    registryNumber: '000119',
    createdAt: '2025-06-16T08:10:00',
    identification: '707070707',
    commercialName: 'Panadería El Trigal, SRL',
    legalRepresentative: 'José Santana',
    status: 'CREATION_ERROR',
    bhdExecutive: 'JPEREZ',
    commercialAssignee: 'María Gómez',
  },
  {
    id: '000118',
    registryNumber: '000118',
    createdAt: '2025-06-13T14:45:00',
    identification: '808080808',
    commercialName: 'Farmacia San Rafael, SRL',
    legalRepresentative: 'Altagracia Núñez',
    status: 'COMMERCE_CREATED',
    bhdExecutive: 'MLOPEZ',
    commercialAssignee: 'Carlos Ruiz',
  },
  {
    id: '000117',
    registryNumber: '000117',
    createdAt: '2025-06-12T10:20:00',
    identification: '909090909',
    commercialName: 'Repuestos del Este, SRL',
    legalRepresentative: 'Ramón Peguero',
    status: 'PENDING_INFORMATION',
    bhdExecutive: 'CAROR',
    commercialAssignee: 'María Gómez',
  },
  {
    id: '000116',
    registryNumber: '000116',
    createdAt: '2025-06-11T16:05:00',
    identification: '111213141',
    commercialName: 'Salón Bella Vista, SRL',
    legalRepresentative: 'Yohanna Encarnación',
    status: 'DRAFT',
    bhdExecutive: 'JPEREZ',
    commercialAssignee: 'Carlos Ruiz',
  },
  {
    id: '000115',
    registryNumber: '000115',
    createdAt: '2025-06-10T09:15:00',
    identification: '212223242',
    commercialName: 'Ferretería Los Almendros, SRL',
    legalRepresentative: 'Miguel Ventura',
    status: 'IN_PROGRESS',
    bhdExecutive: 'MLOPEZ',
    commercialAssignee: 'María Gómez',
  },
  {
    id: '000114',
    registryNumber: '000114',
    createdAt: '2025-06-09T11:50:00',
    identification: '313233343',
    commercialName: 'Supermercado La Fe, SRL',
    legalRepresentative: 'Rosanna Beltré',
    status: 'REQUEST_CANCELLED',
    bhdExecutive: 'CAROR',
    commercialAssignee: 'Carlos Ruiz',
  },
  {
    id: '000113',
    registryNumber: '000113',
    createdAt: '2025-06-06T08:35:00',
    identification: '414243444',
    commercialName: 'Auto Lavado Duarte, SRL',
    legalRepresentative: 'Franklin Ogando',
    status: 'DRAFT',
    bhdExecutive: 'JPEREZ',
    commercialAssignee: 'María Gómez',
  },
  {
    id: '000112',
    registryNumber: '000112',
    createdAt: '2025-06-05T15:10:00',
    identification: '515253545',
    commercialName: 'Colmado Hermanos Then, SRL',
    legalRepresentative: 'Wilkin Then',
    status: 'CREATION_ERROR',
    bhdExecutive: 'MLOPEZ',
    commercialAssignee: 'Carlos Ruiz',
  },
];
